import React from 'react';
import { ShieldCheck, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-4 pb-2 md:pt-8 md:pb-5 px-4 overflow-hidden" data-id="element-99">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-100">
        <div className="flex flex-col gap-2 md:gap-3 max-w-2xl w-full items-center hero-animate" data-id="element-101">
          <h1 className="text-2xl md:text-4xl lg:text-5xl leading-[1.2] text-text-primary font-bold text-center" data-id="element-102">
            Prepará 15 días de comidas en 2 horas y comé{' '}
            <span className="text-primary font-italic italic" data-id="element-103">
              saludable y variado
            </span>
          </h1>

          <p className="text-sm md:text-lg text-text-secondary font-bold text-center" data-id="element-104">
            Sin volver a cocinar todos los días ni gastar más en delivery.
          </p>

          <div className="relative w-full mt-1 rounded-2xl overflow-hidden shadow-xl hero-image-animate" style={{
          aspectRatio: '16/9'
        }} data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/8ftLEeK2RTLSdnhb697fhV/Mockup_Oferta.png" alt="200 Recetas Inteligentes 15D — Sistema completo con bonos, planificador semanal y calculadora de porciones" width={1920} height={1080} className="w-full h-full object-cover" fetchPriority="high" decoding="sync" data-id="element-106" />
          </div>

          {/* Social Proof Pills */}
          <div className="flex flex-col items-center gap-2 mt-1 w-full hero-proof-animate" data-id="element-107">
            <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-108">
              <span className="inline-flex items-center gap-1.5 bg-primary text-white px-3 py-1.5 rounded-full text-[11px] md:text-xs font-bold uppercase tracking-wide shadow-sm" data-id="element-109">
                <span className="text-sm" data-id="element-110">📖</span>
                +200 Recetas
              </span>
              <span className="inline-flex items-center gap-1.5 border-2 border-primary bg-primary/5 text-primary px-3 py-1.5 rounded-full text-[11px] md:text-xs font-bold uppercase tracking-wide shadow-sm" data-id="element-111">
                <ShieldCheck size={14} strokeWidth={2.5} data-id="element-112" />
                30 Días de Garantía
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-113">
              <div className="flex" data-id="element-114">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="#FACC15" stroke="#FACC15" data-id="element-115" />)}
              </div>
              <span className="text-xs md:text-sm font-bold text-text-primary" data-id="element-116">
                4.9/5
              </span>
              <span className="text-xs md:text-sm text-text-secondary font-medium" data-id="element-117">
                — Clientes Satisfechos
              </span>
            </div>
          </div>

          <div className="mt-1 md:mt-3 space-y-1.5 w-full hero-cta-animate" data-id="element-118">
            <CTAButton large data-id="element-119">QUIERO MIS 200 RECETAS</CTAButton>
            <p className="text-[10px] md:text-xs text-center text-text-secondary font-bold uppercase tracking-wide" data-id="element-120">
              Acceso inmediato · Pago único · Garantía 30 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}